import { Button, Table } from 'antd';
import { Container, Plus } from 'lucide-react';
import { useNavigate } from 'react-router';
import { EmptyState } from '../../../../../shared/components/EmptyState';
import { TableSkeleton } from '../../../../../shared/components/TableSkeleton';
import { newVehicleClassPath, vehicleClassPath } from '../../tyre-layouts/tyre-layouts.paths';
import type { TrailerType } from '../../../reference-data.api';
import { buildTrailerTypeColumns } from './build-trailer-type-columns';

interface TrailerTypesPanelProps {
  types: TrailerType[];
  loading: boolean;
  onDeactivate: (row: TrailerType) => Promise<void>;
  onReactivate: (row: TrailerType) => Promise<void>;
}

/**
 * Client-side paging (Ant's default) — the small-fixed-catalogue exception to server-side lists (CLAUDE.md → Lists and tables).
 * A type is created and edited on its own page, with its vehicle beside the form.
 */
export function TrailerTypesPanel({ types, loading, onDeactivate, onReactivate }: TrailerTypesPanelProps) {
  const navigate = useNavigate();
  const columns = buildTrailerTypeColumns({ onEdit: (row) => navigate(vehicleClassPath('trailer_type', row.code)), onDeactivate, onReactivate });
  const newButton = (
    <Button type="primary" icon={<Plus className="size-4" />} onClick={() => navigate(newVehicleClassPath('trailer_type'))}>
      New trailer type
    </Button>
  );

  return (
    <div className="flex flex-col gap-4">
      <div className="flex justify-end">{newButton}</div>
      {loading && <TableSkeleton label="Loading trailer types" />}
      {!loading && types.length === 0 && (
        <EmptyState icon={Container} title="No trailer types yet" description="Add the trailer types this deployment uses.">
          {newButton}
        </EmptyState>
      )}
      {!loading && types.length > 0 && <Table rowKey="id" dataSource={types} columns={columns} pagination={{ pageSize: 25 }} scroll={{ x: 'max-content' }} />}
    </div>
  );
}
